<template>
    <div class="reservas">
        <MenuOpcion :titulo="titulo">            
            <!-- <template v-slot:content>
                <b-nav-form>
                    <b-form-input size="sm" class="mr-sm-2" placeholder="Reserva,Paquete,Cliente ..."></b-form-input>
                    <b-button size="sm" class="my-2 my-sm-0" type="submit">BUSCAR</b-button>
                </b-nav-form>                    
                <div class="float-right">
                    <b-btn 
                        variant="success"
                        v-b-tooltip.hover title="Actualizar"                         
                        @click="actualizarLista"
                    >@
                    </b-btn>                                        
                </div>
            </template> -->            
            <template v-slot:content>        
                <div class="float-right">
                    <b-btn v-if="!ver_reserva"
                        variant="outline-primary" size="sm"
                        v-b-tooltip.hover title="Actualizar Listado"                         
                        @click="actualizarLista"
                    >ACTUALIZAR
                    </b-btn>                                        
                    <b-btn v-else
                        variant="outline-primary" size="sm"
                        v-b-tooltip.hover title="Cambiamos a Listado de Reservas"                         
                        @click="listado"
                    >LISTA
                    </b-btn>                                        
                </div>
            </template>

        </MenuOpcion>
        
        <listaReservas class="mt-2" ref="listaR" v-show="!ver_reserva"/>
        <reserva class="mt-2" ref="reserva" v-show="ver_reserva"/>        
        
    </div>
</template>

<script>

import MenuOpcion from '@/components/MenuOpcion.vue'
import listaReservas from '@/components/listaReservas.vue'
import reserva from '@/components/reserva.vue'


export default {
    name: 'reservas',
    components: {
        MenuOpcion, listaReservas, reserva,
    },
    data() {
        return {
            titulo: 'RESERVAS',
        }
    },
    computed: {
        ver_reserva() {
            return this.$store.state.reserva.id;
        },
    },
    methods: {
        actualizarLista() {
            this.$refs.listaR.leemos();
            //this.$store.ListaReservas.leemosReservas();
            //this.listado();
        },  
        listado() {            
            this.$refs.listaR.leemos();
            this.$store.state.reserva={id:0,tpp:''};            
        }
    },  

    created() {

        //inicializamos ver_reserva    
        this.$store.state.reserva={id:0,tpp:''}; 
    },
}
</script>